import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'
import Modal from 'react-modal';

import { SingleInput } from '../../Res/BaseInput';
import { Space, SearchButton, CancelButton, SingleButton } from '../../Res/BaseButton';
import { ContentBox } from '../../Content/ContentBox';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { getval2Token, getUserInfoCompanyId, setVal2Token } from '../../../Login/Auth';
import { ManagementPrompt } from '../../Res/ManagementPrompt';
import moment from 'moment';
import { ReqContractorAttendanceSOPList } from '../../../../item/ItemContractorAttendance';
import { DatePickerInput } from 'rc-datepicker';
import { Dialog, Button, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import { api_getContractorAttendanceSOP1List } from '../../../../api/apiContractorAttendancee';


export function ContractorAttendanceSOPAddStep1({ id, setIsLoading, action }) {
  const [tokenId, setTokenId] = useState("")
  const [companyId] = useState(getUserInfoCompanyId())

  const [companyName, setCompanyName] = useState("")

  const [customerAttendanceSOP1List, setCustomerAttendanceSOP1List] = useState([])

  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")

  const [startError, setStartError] = useState(false)
  const [endError, setEndError] = useState(false)

  const [modalIsOpen, setIsOpen] = React.useState(false);

  useEffect(() => {
    if (id !== undefined && id !== tokenId) {
      var obj = getval2Token("recruitmentContractorStatus", id)
      // console.log(obj)
      setTokenId(id)
    }
  }, [id])
  // useEffect(() => {
  //   if (id !== undefined && id !== tokenId) {
  //     var rId = getval2Token("resumeId", id)
  //     setResumeId(rId)
  //     setTokenId(id)
  //   }
  // }, [id])

  function toSearch() {
    if (companyName === "")
      return
    var mReqContractorAttendanceSOPList = new ReqContractorAttendanceSOPList({ companyId, start: 0, limit: 1000, companyName })
    getContractorAttendanceSOP1List(mReqContractorAttendanceSOPList)
  }

  function getContractorAttendanceSOP1List(mReqContractorAttendanceSOPList) {
    if (setIsLoading !== undefined)
      setIsLoading(true)
    //console.log("getCustomerContractList")
    //console.log(mReqCustomerContractList)
    api_getContractorAttendanceSOP1List({
      mReqContractorAttendanceSOPList,
      success: (obj) => {
        console.log(obj)
        setCustomerAttendanceSOP1List(obj.list)
        setStartDate(moment().subtract(1, 'months').startOf('month').format('YYYY/MM/DD'))
        setEndDate(moment().subtract(1, 'months').endOf('month').format('YYYY/MM/DD'))
        setIsLoading(false)
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
        //window.location.replace("/AdminManagerList");
      }
    })
  }



  function toCancel() {
    setCompanyName("")
    setCustomerAttendanceSOP1List([])
  }

  function choose(item) {
    if (startError || endError) {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: "起迄時間格式有誤, 請再次確認",
      })
      return
    }
    action(item, startDate, endDate)
  }

  const onChangeStartDate = (jsDate, dateString) => {
    //console.log(jsDate)
    //console.log(dateString)
    if (dateString === "Invalid date") {
      setStartError(true)
    } else {
      setStartError(false)
      setStartDate(dateString)
    }
  }

  const onChangeEndDate = (jsDate, dateString) => {
    //console.log(jsDate)
    //console.log(dateString)
    if (dateString === "Invalid date") {
      setEndError(true)
    } else {
      setEndError(false)
      setEndDate(dateString)
    }
  }
  Modal.setAppElement('#root')

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)'
    }
  };

  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState('paper');

  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  var title = "登錄作業新增Step 1：請先挑選“合約廠商”"
  var content =
    <>
    {/*
      <Button onClick={handleClickOpen('paper')}>scroll=paper</Button>
      <Button onClick={handleClickOpen('body')}>scroll=body</Button>
      <Dialog
        disableEscapeKeyDown={true}
        disableBackdropClick={true}
        open={open}
        fullWidth={true}
        maxWidth={"sm"}

        onClose={handleClose}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">Subscribe</DialogTitle>
        <DialogContent dividers={scroll === 'paper'}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            <><div className="hr-line-dashed"></div>
              <div className="row">
                <div className="col-md-12">
                  <div className="col-md-6">
                    <p>請選擇計算起始日期</p>
                    <DatePickerInput
                      displayFormat='YYYY/MM/DD'
                      returnFormat='YYYY/MM/DD'
                      onChange={onChangeStartDate}
                      value={startDate}
                      className='my-react-component'
                    />
                  </div>
                </div>
              </div>
              <div className="hr-line-dashed"></div>
              <div className="row">
                <div className="col-md-12">
                  <div className="col-md-6">
                    <p>請選擇計算結束日期</p>
                    <DatePickerInput
                      displayFormat='YYYY/MM/DD'
                      returnFormat='YYYY/MM/DD'
                      onChange={onChangeEndDate}
                      value={endDate}
                      className='my-react-component'
                    />
                  </div>
                </div>
              </div>
              <div className="hr-line-dashed"></div>
              <div className="row">
                <div className="col-md-12">
                  <div className="col-md-6">
                    <p>請選擇計算結束日期</p>
                    <DatePickerInput
                      displayFormat='YYYY/MM/DD'
                      returnFormat='YYYY/MM/DD'
                      onChange={onChangeEndDate}
                      value={endDate}
                      className='my-react-component'
                    />
                  </div>
                </div>
              </div>
              <div className="hr-line-dashed"></div>
              <div className="row">
                <div className="col-md-12">
                  <div className="col-md-6">
                    <p>請選擇計算結束日期</p>
                    <DatePickerInput
                      displayFormat='YYYY/MM/DD'
                      returnFormat='YYYY/MM/DD'
                      onChange={onChangeEndDate}
                      value={endDate}
                      className='my-react-component'
                    />
                  </div>
                </div>
              </div>
              <div className="hr-line-dashed"></div>
              <div className="row">
                <div className="col-md-12">
                  <div className="col-md-6">
                    <p>請選擇計算結束日期</p>
                    <DatePickerInput
                      displayFormat='YYYY/MM/DD'
                      returnFormat='YYYY/MM/DD'
                      onChange={onChangeEndDate}
                      value={endDate}
                      className='my-react-component'
                    />
                  </div>
                </div>
              </div>
              <div className="hr-line-dashed"></div>
            </>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleClose} color="primary">
            Subscribe
          </Button>
        </DialogActions>
      </Dialog>
    */}

      <div className="row">
        <div className="col-md-12">
          <SingleInput val={companyName} action={setCompanyName} placeholder={"請輸入廠商名稱，進行搜尋"} size={6} />
          <div className="col-md-3">
            <SearchButton action={toSearch} />
            <CancelButton name={"清除"} action={toCancel} />
          </div>
        </div>
      </div>
      {customerAttendanceSOP1List.length === 0 ? <></> :
        <>
          <div className="hr-line-dashed"></div>
          <div className="row">
            <div className="col-md-12">
              <div className="col-md-3">
                <p>請選擇計算起始日期</p>
                <DatePickerInput
                  displayFormat='YYYY/MM/DD'
                  returnFormat='YYYY/MM/DD'
                  onChange={onChangeStartDate}
                  value={startDate}
                  className='my-react-component'
                />
              </div>
              <div className="col-md-3">
                <p>請選擇計算結束日期</p>
                <DatePickerInput
                  displayFormat='YYYY/MM/DD'
                  returnFormat='YYYY/MM/DD'
                  onChange={onChangeEndDate}
                  value={endDate}
                  className='my-react-component'
                />
              </div>
            </div>
          </div>
          <div className="hr-line-dashed"></div>
        </>
      }
      {customerAttendanceSOP1List.map((item) => (
        <ContractorAttendanceSOPBox key={item.customerContractId} item={item} action={choose} />
      ))}
    </>

  return (
    <>
      <ContentBox title={title} titleSize={6} content={content} hasDrawer={false} />
      <ManagementPrompt />
      <SystemPromptInput />
    </>
  )
}


function ContractorAttendanceSOPBox({ item, action }) {
  const [mItem, setItem] = useState({})
  const [companyName, setCompanyName] = useState("")
  const [signAt, setSignAt] = useState("")

  useEffect(() => {
    if (item !== undefined && item !== mItem) {
      //console.log(item)
      setItem(item)
      setCompanyName(item.companyName)
      setSignAt(moment(item.signAt).format('YYYY-MM'))
    }
  }, [item])

  function toAction(){
    action(mItem)
  }

  return (
    <div className="row m-b-sm" key={mItem.customerPositionId}>
      <div className="col-md-12">
        <div className="col-md-5">
          {signAt} {companyName}
        </div>
        <div className="col-md-1">
          <SearchButton action={toAction} name = "試算" icon = "" />
        </div>

      </div>
    </div>
  )
}
